module.exports = __webpack_public_path__ + "static/media/Anfahrt1.5bffd495.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Anfahrt1.jpg
// module id = 326
// module chunks = 0